.log-id-box{display:flex;padding:4px 0;justify-content:center;align-items:center;gap:10px;border-radius:4px;border:1.5px solid rgba(35,36,38,.12);background:#5a42d014}.log-id{color:#232426de;font-weight:500}
/*# sourceMappingURL=debug-log-id.component.css.map */
